// extracted by mini-css-extract-plugin
export default {"previewBox":"previewBox__previewBox--gYdwL","previewContentContainer":"previewBox__previewContentContainer--875xn","buttonContainer":"previewBox__buttonContainer--FhikL"};